import home from "../assets/header-icons/home.png";
import team from "../assets/header-icons/team.png";
import time from "../assets/header-icons/time.png";
import growth from "../assets/header-icons/growth.png";
import files from "../assets/header-icons/files.png";
import tasks from "../assets/header-icons/tasks.png";
import benefits from "../assets/header-icons/benefits.png";
import analysis from "../assets/header-icons/analysis.png";
import payroll from "../assets/header-icons/payroll.png";
import settings from "../assets/header-icons/settings.png";

export const headerLinks = [
  { id: 1, name: "home", icon: home, link: "/" },
  {
    id: 2,
    name: "team",
    icon: team,
    subMenu: [
      {
        id: 1,
        heading: "",
        links: [
          {
            id: 1,
            name: "employee directory",
            path: "/team/employee-directory",
          },
          { id: 2, name: "company structure", path: "/team/company-structure" },
          { id: 3, name: "employees club", path: "/team/employee-club" },
          { id: 4, name: "import people", path: "/team/import-people" },
          { id: 5, name: "recruitment", path: "/team/recruitment" },
        ],
      },
    ],
  },
  {
    id: 3,
    name: "time",
    icon: time,
    subMenu: [
      {
        id: 1,
        heading: "time off",
        links: [
          { id: 1, name: "my time off", path: "/time/my-time-off" },
          { id: 2, name: "employee time off", path: "/time/employee-time-off" },
          { id: 3, name: "time off calendar", path: "/time/time-off-calendar" },
          { id: 4, name: "time off request", path: "/time/time-off-request" },
          { id: 5, name: "policy balance", path: "/time/policy-balance" },
          { id: 6, name: "import time off", path: "/time/import-time-off" },
        ],
      },
      {
        id: 2,
        heading: "attendance",
        links: [
          { id: 1, name: "my attendance", path: "/time/my-attendance" },
          {
            id: 2,
            name: "employee attendance",
            path: "/time/employee-attendance",
          },
        ],
      },
    ],
  },
  {
    id: 4,
    name: "growth",
    icon: growth,
    subMenu: [
      { id: 1, singleName: "survey", singlePath: "/growth/survey" },
      {
        id: 2,
        heading: "performance",
        links: [
          { id: 1, name: "my evaluation", path: "/growth/my-evaluation" },
          { id: 2, name: "team evaluation", path: "/growth/team-evaluation" },
          {
            id: 3,
            name: "employee evaluation",
            path: "/growth/employee-evaluation",
          },
        ],
      },
      {
        id: 3,
        heading: "goals",
        links: [
          { id: 1, name: "my goals", path: "/growth/my-goals" },
          { id: 2, name: "team goals", path: "/growth/team-goals" },
          { id: 3, name: "employee goals", path: "/growth/employee-goals" },
        ],
      },
      { id: 4, singleName: "1-on-1s", singlePath: "/growth/1-on-1s" },
    ],
  },
  {
    id: 5,
    name: "files",
    icon: files,
    subMenu: [
      {
        id: 1,
        heading: "",
        links: [
          { id: 1, name: "my files", path: "/files/my-files" },
          { id: 2, name: "employee files", path: "/files/employee-files" },
          { id: 3, name: "company files", path: "/files/company-files" },
          {
            id: 4,
            name: "confidential files",
            path: "/files/confidential-files",
          },
          { id: 5, name: "E-Sign files", path: "/files/e-sign-files" },
        ],
      },
    ],
  },
  {
    id: 6,
    name: "tasks",
    icon: tasks,
    subMenu: [
      {
        id: 1,
        heading: "",
        links: [
          { id: 1, name: "my tasks", path: "/tasks/my-tasks" },
          { id: 2, name: "employee tasks", path: "/tasks/employee-tasks" },
          { id: 3, name: "manage tasks", path: "/tasks/manage-tasks" },
        ],
      },
    ],
  },
  {
    id: 7,
    name: "benefits",
    icon: benefits,
    subMenu: [
      {
        id: 1,
        heading: "",
        links: [
          { id: 1, name: "my benefits", path: "/benefits/my-benefits" },
          { id: 2, name: "benefit details", path: "/benefits/benefit-details" },
          {
            id: 3,
            name: "benefit requests",
            path: "/benefits/benefit-requests",
          },
        ],
      },
    ],
  },
  {
    id: 8,
    name: "analysis",
    icon: analysis,
    subMenu: [
      {
        id: 1,
        heading: "",
        links: [
          {
            id: 1,
            name: "analytics dashboard",
            path: "/analysis/analytics-dashboard",
          },
          { id: 2, name: "reports", path: "/analysis/reports" },
        ],
      },
    ],
  },
  {
    id: 9,
    name: "payroll",
    icon: payroll,
    subMenu: [
      {
        id: 1,
        heading: "",
        links: [
          {
            id: 1,
            name: "payroll analytics",
            path: "/payroll/payroll-analytics",
          },
          { id: 2, name: "company payroll", path: "/payroll/company-payroll" },
          {
            id: 3,
            name: "employee payroll",
            path: "/payroll/employee-payroll",
          },
        ],
      },
    ],
  },
  {
    id: 10,
    name: "settings",
    icon: settings,
    subMenu: [
      {
        id: 1,
        heading: "",
        links: [
          { id: 1, name: "my company", path: "/settings/my-company" },
          { id: 2, name: "locations", path: "/settings/locations" },
          { id: 3, name: "departments", path: "/settings/departments" },
          { id: 4, name: "calendars", path: "/settings/calendars" },
          { id: 5, name: "flows", path: "/settings/flows" },
          { id: 6, name: "time off", path: "/settings/time-off" },
          { id: 7, name: "attendance", path: "/settings/attendance" },
          { id: 8, name: "surveys", path: "/settings/surveys" },
          { id: 9, name: "performance", path: "/settings/performance" },
          { id: 10, name: "1-on-1s", path: "/settings/1-on-1s" },
          { id: 11, name: "files", path: "/settings/files" },
          { id: 12, name: "tasks", path: "/settings/tasks" },
          { id: 13, name: "benefits", path: "/settings/benefits" },
          { id: 14, name: "payroll", path: "/settings/payroll" },
          {
            id: 15,
            name: "rola & permissions",
            path: "/settings/role-&-permissions",
          },
          { id: 16, name: "integrations", path: "/settings/integrations" },
          {
            id: 17,
            name: "personalisation",
            path: "/settings/personalisation",
          },
        ],
      },
    ],
  },
];
